import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    setEditedEvent,
    setModalViewActualTab,
    setAddEventMode,
    setDuplicatedEventId,
    toggleAddModal,
    toggleEditModal,
    toggleNeedRefresh,
    clearDuplicatedEventId
} from '../../store/eventsSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';
import './Events.css';
import './ModalX.css';
import './Stepper.css';

function AddEvent() {
    const dispatch = useDispatch();

    const addEventMode = useSelector((state) => state.events.addEventMode);

    const editedEvent = useSelector((state) => state.events.editedEvent);
    const duplicatedEventId = useSelector((state) => state.events.duplicatedEventId);
    const isAddModalOpen = useSelector((state) => state.events.addModalOpen);
    const isEditModalOpen = useSelector((state) => state.events.editModalOpen);
    const modalViewActualTab = useSelector((state) => state.events.modalViewActualTab);
    // Stan dla zdjęcia głównego: { file: File | null, preview: string | null, id: string | null }
    const [mainImage, setMainImage] = useState({ file: null, preview: null, id: null });

    const accessToken = useSelector((state) => state.tokens.accessToken);

    // Stan dla zdjęć dodatkowych: tablica obiektów [{ file: File, preview: string, id: string | null }]
    const [additionalImages, setAdditionalImages] = useState([]);

    const modalViewTabs = [
        "Dane podstawowe",
        "Opis",
        "Multimedia",
    ]

    const [imageHashCode, setImageHashCode] = useState('');

    const MAX_FILE_SIZE = 5242880; // 5MB

    const [formData, setFormData] = useState({
        name: '',
        category: '',
        startDate: '',
        eventTime: '00:00',
        eventEndDate: '',
        eventEndTime: '00:00',
        place: '',
        adres: '',
        city: 'Warszawa',
        ticketInfo: '',
        ticketPrice: '0',
        description: '',
        zipCode: '',
        added_on_utc: '',
        isActive: true,
        tags: [],
    });
    const [categories, setCategories] = useState([]);
    const [isTagModalOpen, setIsTagModalOpen] = useState(false);
    const [tagInput, setTagInput] = useState('');

    const fetchCategories = async () => {
        const response = await ApiService.getEventsCategories();
        setCategories(response.data);
    };

    const fetchImages = async (imgId) => {
        try {
            const imgResponse = await fetch(`/api/events-images/${imgId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
                credentials: 'include',
                mode: 'cors'
            });
            if (!imgResponse.ok) {
                throw new Error(`HTTP error! status: ${imgResponse.status}`);
            }
            const blob = await imgResponse.blob();
            // Tworzymy obiekt File, aby spełnić warunki walidacji (mainImage.file)
            // const file = new File([blob], "mainImage.jpg", {type: blob.type});
            const preview = URL.createObjectURL(blob);

            return preview;
        } catch (error) {
            console.error("Błąd pobierania zdjęcia głównego:", error);
        }
    }

    const fetchEvent = async () => {
        const response = await ApiService.getEvent(editedEvent);
        const defaultImage = response.data.image_hash_code;
        console.log(response.data);
        setFormData({
            ...response.data,
            category: String(response.data.categoryId),
            startDate: response.data.startDate ? response.data.startDate.split('T')[0] : '',
            eventEndDate: response.data.endDate ? response.data.endDate.split('T')[0] : '',
            // Wyciągamy HH:MM (bierzemy 5 pierwszych znaków po 'T')
            eventTime: response.data.startDate && response.data.startDate.includes('T') ? response.data.startDate.split('T')[1].substring(0, 5)  : '',
            tags: Array.isArray(response.data.tags) ? response.data.tags : [],
        });
        setImageHashCode(defaultImage)
        if (defaultImage) {
                const preview = await fetchImages(defaultImage);
                setMainImage({ file: null, preview, id: defaultImage });
        }
    }

    const fetchEventForDuplicate = async (eventId) => {
        const response = await ApiService.getEvent(eventId);
        const defaultImage = response.data.image_hash_code;
        console.log(response.data);
        setFormData({
            ...response.data,
            added_on_utc: '',
            category: String(response.data.categoryId),
            startDate: response.data.startDate ? response.data.startDate.split('T')[0] : '',
            eventEndDate: response.data.endDate ? response.data.endDate.split('T')[0] : '',
            // WyciÄ…gamy HH:MM (bierzemy 5 pierwszych znakÃ³w po 'T')
            eventTime: response.data.startDate && response.data.startDate.includes('T') ? response.data.startDate.split('T')[1].substring(0, 5)  : '',
            tags: Array.isArray(response.data.tags) ? response.data.tags : [],
        });
        setImageHashCode(defaultImage || '');
        if (defaultImage) {
            const preview = await fetchImages(defaultImage);
            setMainImage({ file: null, preview, id: defaultImage });
        } else {
            setMainImage({ file: null, preview: null, id: null });
        }
        setAdditionalImages([]);
    }

    const fetchEventPhotos = async () => {
        const response = await ApiService.getAllImagesForEvent(editedEvent);
        console.log(response);
        const images = response.data;
        const loadedImages = [];
        if (images.length > 0) {
            for (const img of images) {

                if (!(imageHashCode === img)) {
                    console.log(img + "  vs  " + imageHashCode);
                    // Pobieramy blob (zakładam, że fetchImages zwraca URL lub blob URL)
                    const preview = await fetchImages(img);

                    // Dodajemy do lokalnej tablicy zamiast od razu do stanu
                    loadedImages.push({file: null, preview: preview, id: img});
                }
            }
        }

        // Aktualizujemy stan TYLKO RAZ, nadpisując wszystko nową listą
        // Dzięki temu unikamy duplikatów i zbędnych przerysowań
        setAdditionalImages(loadedImages);
    };


    useEffect(() => {
        const loadData = async () => {
            await fetchCategories();
            if (isEditModalOpen) {
                await fetchEvent();
                // fetchEventPhotos() będzie się wykonać po fetchEvent()
            }
        };

        loadData();
    }, [isEditModalOpen]);

    useEffect(() => {
        if (isAddModalOpen && duplicatedEventId) {
            fetchCategories();
            fetchEventForDuplicate(duplicatedEventId);
        }
    }, [isAddModalOpen, duplicatedEventId]);

// Osobny useEffect dla zdjęć dodatkowych
    useEffect(() => {
        if (isEditModalOpen && imageHashCode) {  // ← Czekaj aż imageHashCode się ustawi
            fetchEventPhotos();
        }
    }, [imageHashCode, isEditModalOpen]);


    useEffect(() => {
        const isValid =
            formData.name &&
            formData.category &&
            formData.startDate &&
            formData.eventEndDate &&
            formData.startDate <= formData.eventEndDate &&
            formData.place &&
            formData.city &&
            formData.ticketInfo &&
            formData.description;

        setIsSubmitDisabled(!isValid);
    }, [formData, mainImage, additionalImages]);

    // --- NOWA LOGIKA ZDJĘĆ ---
    const defaultPlaceholder = "./x3.jpg";

    const handleDuplikujClick = () => {
        dispatch(setAddEventMode(true));
        dispatch(setModalViewActualTab("Dane podstawowe"));
        dispatch(setDuplicatedEventId(editedEvent));
        dispatch(toggleEditModal());
        dispatch(toggleAddModal());
    }

    // Nowa funkcja do usuwania zdjęcia
    const handleRemoveImage = (indexToRemove) => {
        setAdditionalImages(prev => prev.filter((_, index) => index !== indexToRemove));
        if (isEditModalOpen) {
            const id = additionalImages[indexToRemove].id;
            console.log("usuwam " + id);
            ApiService.deleteEventImage(id);
        }
    };

    // Handler dla wyboru zdjęcia głównego
    const handleMainImageChange = async (e) => {
        const file = e.target.files[0];

        if (file && file.size > MAX_FILE_SIZE) {
            alert("Plik jest zbyt duży. Maksymalna wielkość to 5 MB.");
            e.target.value = ""; // Reset inputa
            return;
        }

        let imageHashCode;
        if (isEditModalOpen) {
            imageHashCode = await ApiService.uploadEventImage(editedEvent, file);
            setImageHashCode(imageHashCode);
            await saveMainImage(imageHashCode);
        }
        if (file) {
            setMainImage({
                file: file,
                preview: URL.createObjectURL(file),
                id: imageHashCode
            });
        }
    };

    // Handler dla wyboru wielu zdjęć dodatkowych
    const handleAdditionalImagesChange = async (e) => {
        const files = Array.from(e.target.files);

        if (files.length > 0) {
            const newImages = [];
            for (const file of files) {
                if (file.size > MAX_FILE_SIZE) {
                    alert(`Plik "${file.name}" jest zbyt duży. Został pominięty. Maksymalna wielkość to 5 MB.`);
                    continue;
                }

                let imageHashCode;
                if (isEditModalOpen) {
                    imageHashCode = await ApiService.uploadEventImage(editedEvent, file);
                }
                newImages.push({
                    file: file,
                    preview: URL.createObjectURL(file),
                    id: imageHashCode
                });
            }
            setAdditionalImages(prev => [...prev, ...newImages]);
        }
    };

    // Funkcja zamieniająca zdjęcie dodatkowe z głównym
    const handleSwapImage = async (indexToSwap) => {
        const imageFromAdditional = additionalImages[indexToSwap];
        const currentMain = mainImage;

        // 1) ZAWSZE aktualizujemy stan lokalny (działa i dla dodawania, i dla edycji)
        setMainImage(imageFromAdditional);

        // 2) Tylko w trybie edycji synchronizujemy backend (mamy już istniejący event + id obrazka)
        if (isEditModalOpen) {
            const newMainHash = imageFromAdditional?.id;

            // Jeśli obrazek pochodzi z pliku i nie ma jeszcze id (hash),
            // to nie ma czego zapisać jako main na backendzie na tym etapie.
            if (newMainHash) {
                setImageHashCode(newMainHash);
                await saveMainImage(newMainHash);
            }
        }

        // 3) Aktualizujemy listę dodatkowych (swap / replace)
        const newAdditionalList = [...additionalImages];

        if (currentMain.file || currentMain.preview) {
            newAdditionalList[indexToSwap] = currentMain;
        } else {
            newAdditionalList.splice(indexToSwap, 1);
        }

        setAdditionalImages(newAdditionalList);
    };
    // -------------------------

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

    const handleInputChange = (e) => {
        // Usuwamy st?d logik? walidacji, zostawiamy tylko aktualizacj? stanu
        const { name, value } = e.target;
        setFormData((prev) => {
            if (name === "startDate" && prev.eventEndDate && value && value > prev.eventEndDate) {
                return { ...prev, [name]: value, eventEndDate: "" };
            }

            return { ...prev, [name]: value };
        });
        console.log(formData);
    };

    const handleNextButtonClick = () => {
        const actual = modalViewTabs.indexOf(modalViewActualTab);
        if (actual < modalViewTabs.length - 1) {
            dispatch(setModalViewActualTab(modalViewTabs[actual + 1]));
        }
    }

    const handlePrevButtonClick = () => {
        const actual = modalViewTabs.indexOf(modalViewActualTab);
        if (actual > 0) {
            dispatch(setModalViewActualTab(modalViewTabs[actual - 1]));
        }
    }

    const closeTagModal = () => {
        setIsTagModalOpen(false);
        setTagInput('');
    };

    const handleAddTag = () => {
        const value = tagInput.trim();
        if (!value) {
            return;
        }
        setFormData((prev) => {
            if (prev.tags.includes(value)) {
                return prev;
            }
            return { ...prev, tags: [...prev.tags, value] };
        });
        closeTagModal();
    };

    const handleRemoveTag = (indexToRemove) => {
        setFormData((prev) => ({
            ...prev,
            tags: prev.tags.filter((_, index) => index !== indexToRemove),
        }));
    };

    const isLastTab =
        (modalViewTabs.indexOf(modalViewActualTab) === modalViewTabs.length - 1)
        || (addEventMode && (modalViewTabs.indexOf(modalViewActualTab) === modalViewTabs.length - 2))
    ;
    const isFirstTab = modalViewTabs.indexOf(modalViewActualTab) === 0;

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // 2. Przygotowanie danych formularza z IDkami zdjęć
            const data = {
                name: formData.name,
                place: formData.place,
                city: formData.city,
                categoryId: Number(formData.category),
                startDate: `${formData.startDate}T${formData.eventTime}:00`,
                endDate: `${formData.eventEndDate}T00:00:00`,
                ticketInfo: formData.ticketInfo,
                ticketPrice: formData.ticketPrice,
                description: formData.description,
                adres: formData.adres,
                zipCode: formData.zipCode,
                tags: formData.tags,
                isActive: true,
                image_hash_code: imageHashCode,
            };


            let response;
            if (isEditModalOpen) {
                response = await ApiService.updateEvent(editedEvent, data);
                dispatch(toggleEditModal());
            }
            if (isAddModalOpen) {
                response = await ApiService.addNewEvent(data);

                // Zapis fotografii dla nowego eventu
                if (response.id) {
                    const eventId = response.id;
                    console.log('Nowe wydarzenie zostało dodane:', eventId);

                    console.log("MainImage " + mainImage.file);

                    // Zapisz główne zdjęcie
                    if (mainImage.file) {
                        const mainHash = await ApiService.uploadEventImage(eventId, mainImage.file);
                        await ApiService.updateEvent(eventId, { image_hash_code: mainHash });
                    }

                    // Zapisz dodatkowe zdjęcia
                    for (const img of additionalImages) {
                        if (img.file) {
                            await ApiService.uploadEventImage(eventId, img.file);
                        }
                    }
                }
                dispatch(toggleAddModal());
            }
            console.log('Wydarzenie zostało dodane/zaktualizowane:', response)
            dispatch(toggleNeedRefresh());
            dispatch(clearDuplicatedEventId());

            // Reset formularza i zdjęć (opcjonalnie)
            setMainImage({ file: null, preview: null, id: null });
            setAdditionalImages([]);

        } catch (error) {
            console.error('Błąd podczas dodawania nowego wydarzenia:', error);
        }
    };

    const saveMainImage = async (imageHashCode) => {

        try {
            // 2. Przygotowanie danych formularza z IDkami zdjęć
            const data = {
                id: editedEvent,
                image_hash_code: imageHashCode
            };

            let response;
            if (isEditModalOpen) {
                response = await ApiService.updateEvent(editedEvent, data);
            }
            console.log('Wydarzenie zostało zaktualizowane:', response)
            dispatch(toggleNeedRefresh());

        } catch (error) {
            console.error('Błąd podczas dodawania nowego wydarzenia:', error);
        }
    };

    const handleCloseModal = () => {
        if (isAddModalOpen) {
            dispatch(toggleAddModal());
        }
        if (isEditModalOpen) {
            dispatch(toggleEditModal());
        }
        dispatch(clearDuplicatedEventId());
        closeTagModal();
    };

    return (
        <>
        {isTagModalOpen && (
            <Modal
                isOpen={isTagModalOpen}
                onClose={closeTagModal}
                overlayClassName="modal-overlay-top"
                className="modal-content-small"
            >
                <h2>Dodaj tag</h2>
                <div className="flex-container-space-between border-bottom-light">
                    <label htmlFor="tagInput" className="padding-right-20">Nowy tag</label>
                    <input
                        className=""
                        type="text"
                        id="tagInput"
                        name="tagInput"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        title="Wpisz tag"
                    />
                </div>
                <div className="modal-margin-top-20 flex-container-center flex-start text-black">
                    <button className="button-orange-rounded-tiny-textonly text-black" type="button" onClick={closeTagModal}>
                        Anuluj
                    </button>
                    <button className="button-orange-rounded-tiny-textonly text-black" type="button" onClick={handleAddTag}>
                        Dodaj
                    </button>
                </div>
            </Modal>
        )}

        {/* sekcja edycji */}
        { !addEventMode && <Modal isOpen={isAddModalOpen || isEditModalOpen} onClose={handleCloseModal}>
            <h2>{isAddModalOpen ? "Dodaj nowe " : ""} {isEditModalOpen ? "Edytuj ": ""}wydarzenie</h2>
            <div className="userView-menu">
                {
                    modalViewTabs.map((tab, index) => {
                        return (
                            <button
                                type={modalViewActualTab === tab ? "modal-menu-active" : "modal-menu"}
                                id={index}
                                key={index}
                                className={modalViewActualTab === tab ? "buttons-menu-modal-1" : "buttons-menu-modal-2"}
                                onClick= {() => dispatch(setModalViewActualTab(tab))}>{tab}</button>)

                    })
                }
            </div>
            <form onSubmit={handleSubmit}>
                { modalViewActualTab === "Dane podstawowe" &&
                    <>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="name" className="padding-right-20">Nazwa wydarzenia</label>
                            <input
                                className="input-field"
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                title="Wprowadź nazwę wydarzenia"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="category" className="padding-right-20">Kategoria wydarzenia</label>
                            <select
                                className="input-field"
                                type="number"
                                id="category"
                                name="category"
                                value={formData.category}
                                title="Wybierz kategorię wydarzenia"
                                onChange={handleInputChange}
                                required
                            >
                                <option value="" disabled>Wybierz z listy</option>
                                { categories.map(category => (
                                    <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <div>
                                <label htmlFor="startDate" className="padding-right-20">Data wydarzenia</label>
                                <input
                                    className="input-field"
                                    type="date"
                                    id="startDate"
                                    name="startDate"
                                    value={formData.startDate}
                                    onChange={handleInputChange}
                                    title="Wybierz datę wydarzenia"
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="eventTime" className="padding-right-20">Godzina wydarzenia</label>
                                <input
                                    className="input-field"
                                    type="time"
                                    id="eventTime"
                                    name="eventTime"
                                    value={formData.eventTime}
                                    onChange={handleInputChange}
                                    title="Wybierz godzinę wydarzenia (np. 10:10)"
                                />
                            </div>
                            <div>
                                <label htmlFor="eventEndDate" className="padding-right-20">Data zakończenia</label>
                                <input
                                    className="input-field"
                                    type="date"
                                    id="eventEndDate"
                                    name="eventEndDate"
                                    value={formData.eventEndDate}
                                    onChange={handleInputChange}
                                    title="Wybierz datę zakończenia wydarzenia"
                                    min={formData.startDate || undefined}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="ticketInfo" className="padding-right-20">Bilety</label>
                            <input
                                className="input-field"
                                type="text"
                                id="ticketInfo"
                                name="ticketInfo"
                                value={formData.ticketInfo}
                                onChange={handleInputChange}
                                title="Wpisz informacje o biletach"
                                required
                            />
                        </div>
                        <div className="flex-container border-bottom-light">
                            <label htmlFor="ticketPrice" className="padding-right-20">Cena</label>
                            <input
                                className="input-field"
                                type="number"
                                id="ticketPrice"
                                name="ticketPrice"
                                value={formData.ticketPrice}
                                title="Wprowadź minimalną cenę biletu"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="header-group border-bottom">Lokalizacja</div>

                        <div className="flex-container-space-between border-bottom-light">
                            <label htmlFor="place" className="padding-right-20">Nazwa miejsca</label>
                            <input
                                className="input-field"
                                type="text"
                                id="place"
                                name="place"
                                value={formData.place}
                                title="Wprowadź nazwę miejca"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between">
                            <label htmlFor="adres" className="padding-right-20">Adres</label>
                            <input
                                className="input-field"
                                type="text"
                                id="adres"
                                name="adres"
                                value={formData.adres}
                                title="Wprowadź adres"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="flex-container-space-between border-bottom-light">
                            <div>
                                <label htmlFor="zipCode" className="padding-right-20">Kod pocztowy</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="zipCode"
                                    name="zipCode"
                                    value={formData.zipCode}
                                    title="Wprowadź kod pocztowy"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="city" className="padding-right-20">Miejscowość</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="city"
                                    name="city"
                                    value={formData.city}
                                    title="Wprowadź miejscowość"
                                    onChange={handleInputChange}
                                    required
                                    readOnly={true}
                                />
                            </div>
                        </div>
                    </>}

                {modalViewActualTab === "Opis" &&
                    <>
                        <label htmlFor="description">Opis</label>
                        <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <textarea
                                type="text"
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                required
                                className="event-description"
                                style={{ flexGrow: 1 }}
                            />
                        </div>
                        <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                            <label className="padding-right-20" htmlFor="tagListEdit">Tagi</label>
                            <div id="tagListEdit" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', flexGrow: 1 }}>
                                {formData.tags.length > 0 ? (
                                    formData.tags.map((tag, index) => (
                                        <span key={`${tag}-${index}`} style={{ border: '1px solid #ccc', borderRadius: '12px', padding: '2px 8px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                            {tag}
                                            <button
                                                type="button"
                                                className="button-orange-rounded-tiny-textonly"
                                                onClick={() => handleRemoveTag(index)}
                                                title="Usun tag"
                                            >
                                                x
                                            </button>
                                        </span>
                                    ))
                                ) : (
                                    <span>Brak tagow</span>
                                )}
                            </div>
                            <button
                                type="button"
                                className="button-orange-rounded-tiny-plus"
                                onClick={() => setIsTagModalOpen(true)}
                                title="Dodaj tag"
                            >
                                +
                            </button>
                        </div>
                    </>}



                {modalViewActualTab === "Multimedia" &&
                    <>
                        <div className="flex-line border-bottom-light">
                            <label htmlFor="mainImageInput" className="padding-right-20">Zdjęcie główne</label>
                            <img
                                src={mainImage.preview || defaultPlaceholder}
                                className="imgMiniature"
                                alt="Podgląd głównego zdjęcia"
                            />
                            <input
                                className="input-field"
                                type="file"
                                id="mainImageInput"
                                name="mainImageInput"
                                onChange={handleMainImageChange}
                                title="Wybierz plik obrazka głównego"
                                accept="image/png, image/jpeg, image/webp"
                            />
                        </div>
                        <div className="flex-line border-bottom-light">
                            <label htmlFor="additionalImagesInput" className="padding-right-20">Zdjęcia dodatkowe</label>
                            <input
                                className="input-field"
                                type="file"
                                id="additionalImagesInput"
                                name="additionalImagesInput"
                                onChange={handleAdditionalImagesChange}
                                multiple // Obsługa wielu plików
                                title="Wybierz pliki obrazków dodatkowych"
                                accept="image/png, image/jpeg, image/webp"
                            />
                        </div>
                        <div className="flex-line2 border-bottom-light">
                            {additionalImages.length > 0 ? (
                                additionalImages.map((imgData, index) => (
                                    <div key={index} className="image-container">
                                        <img
                                            src={imgData.preview}
                                            className="imgMiniature"
                                            alt={`Dodatkowe ${index}`}
                                        />

                                        {/* Nakładka widoczna po najechaniu myszką */}
                                        <div className="image-overlay ">
                                            {/* Górna część: Usuń */}
                                            <div
                                                className="overlay-action overlay-action-top  delete"
                                                onClick={() => handleRemoveImage(index)}
                                                title="Usuń to zdjęcie"
                                            >
                                                Usuń
                                            </div>

                                            {/* Dolna część: Ustaw główne */}
                                            <div
                                                className="overlay-action overlay-action-bottom set-main"
                                                onClick={() => handleSwapImage(index)}
                                                title="Ustaw jako zdjęcie główne"
                                            >
                                                Główne
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // Wyświetlanie placeholderów gdy brak zdjęć dodatkowych
                                <>
                                    {/*<img src={defaultPlaceholder} className="imgMiniature" alt="puste" />*/}
                                </>
                            )}
                        </div>

                    </>
                }

                    <div className="modal-margin-top-20 modal-actions">
                        <div className="modal-actions-left">
                            <button className="button-orange-rounded" type="button" onClick={handleCloseModal}>
                                Anuluj
                            </button>
                            <button className="button-orange-rounded" disabled={isFirstTab} type="button" onClick={handlePrevButtonClick}>
                                <span className="fontX">&larr;&nbsp;</span>Wstecz
                            </button>
                        </div>
                        <div className="modal-actions-right">
                            <button className="button-orange-rounded" disabled={isLastTab} type="button" onClick={handleNextButtonClick}>
                                Dalej<span className="fontX">&nbsp;&rarr;</span>
                            </button>
                            {isEditModalOpen  &&
                            <button className="button-orange-backgrounded" disabled={isLastTab} type="button" onClick={handleDuplikujClick}>
                                Duplikuj
                            </button>}

                            <button type="submit" disabled={isSubmitDisabled} className="button-orange-backgrounded">
                                {/*<span className="fontX">&#8862;&nbsp;</span>*/}
                                <div className="step-box-plus"></div>
                                {isAddModalOpen ? "Dodaj wydarzenie" : ""} {isEditModalOpen ? "Zapisz zmiany": ""}
                            </button>
                        </div>
                    </div>
            </form>
        </Modal> }

        {/*  sekcja dodawania  */}
            { addEventMode && <Modal className='modal-content-add-event' isOpen={isAddModalOpen || isEditModalOpen} onClose={handleCloseModal}>
                <h2>{isAddModalOpen ? "Dodaj nowe " : ""} {isEditModalOpen ? "Edytuj ": ""}wydarzenie</h2>
                <div className="userView-menu">
                    {/*todo tu wklej pierdolnik kroku!*/}
                    <div className="stepper-container">
                        <div className="stepper-wrapper">

                            {/* Krok 1 */}
                            <div className="step-item completed">
                                <div className="step-box">
                                    { modalViewActualTab === "Dane podstawowe" && <span className="step-number">1</span> }
                                    { modalViewActualTab === "Opis" && <span className="checkmark">✓</span> }
                                </div>
                                <p className="step-label">Dane podstawowe</p>
                            </div>

                            {/* Linia łącząca */}
                            <div className="step-line"></div>

                            {/* Krok 2 */}
                            <div className={ modalViewActualTab === "Dane podstawowe" ? "step-item active step-not-actual" : "step-item active"} >
                                <div className="step-box">
                                    <span className="step-number">2</span>
                                </div>
                                <p className="step-label">Opis i multimedia</p>
                            </div>

                        </div>
                    </div>

                </div>
                <form onSubmit={handleSubmit}>
                    { modalViewActualTab === "Dane podstawowe" &&
                        <>
                            <div className="flex-container-space-between border-bottom-light">
                                <label htmlFor="name" className="padding-right-20">Nazwa wydarzenia</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    title="Wprowadź nazwę wydarzenia"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                <label htmlFor="category" className="padding-right-20">Kategoria wydarzenia</label>
                                <select
                                    className="input-field"
                                    type="number"
                                    id="category"
                                    name="category"
                                    value={formData.category}
                                    title="Wybierz kategorię wydarzenia"
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="" disabled>Wybierz z listy</option>
                                    { categories.map(category => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                <div>
                                    <label htmlFor="startDate" className="padding-right-20">Data rozpoczęcia</label>
                                    <input
                                        className="input-field"
                                        type="date"
                                        id="startDate"
                                        name="startDate"
                                        value={formData.startDate}
                                        onChange={handleInputChange}
                                        title="Wybierz datę wydarzenia"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="eventTime" className="padding-right-20">Godzina</label>
                                    <input
                                        className="input-field"
                                        type="time"
                                        id="eventTime"
                                        name="eventTime"
                                        value={formData.eventTime}
                                        onChange={handleInputChange}
                                        title="Wybierz godzinę wydarzenia (np. 10:10)"
                                    />
                                </div>
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                <div>
                                    <label htmlFor="eventEndDate" className="padding-right-20">Data zakończenia</label>
                                    <input
                                        className="input-field"
                                        type="date"
                                        id="eventEndDate"
                                        name="eventEndDate"
                                        value={formData.eventEndDate}
                                        onChange={handleInputChange}
                                        title="Wybierz datę zakończenia wydarzenia"
                                        min={formData.startDate || undefined}
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="eventEndTime" className="padding-right-20">Godzina</label>
                                    <input
                                        className="input-field"
                                        type="time"
                                        id="eventEndTime"
                                        name="eventEndTime"
                                        value={formData.eventEndTime}
                                        onChange={handleInputChange}
                                        title="Wybierz godzinę wydarzenia (np. 10:10)"
                                    />
                                </div>
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                <label htmlFor="ticketInfo" className="padding-right-20">Wstęp</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="ticketInfo"
                                    name="ticketInfo"
                                    value={formData.ticketInfo}
                                    onChange={handleInputChange}
                                    title="Wpisz informacje o biletach"
                                    required
                                />
                            </div>
                            <div className="flex-container border-bottom-light">
                                <label htmlFor="ticketPrice" className="padding-right-20">Cena</label>
                                <input
                                    className="input-field"
                                    type="number"
                                    id="ticketPrice"
                                    name="ticketPrice"
                                    value={formData.ticketPrice}
                                    title="Wprowadź minimalną cenę biletu"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="header-group border-bottom">Lokalizacja</div>

                            <div className="flex-container-space-between border-bottom-light">
                                <label htmlFor="place" className="padding-right-20">Nazwa miejsca</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="place"
                                    name="place"
                                    value={formData.place}
                                    title="Wprowadź nazwę miejca"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                <label htmlFor="adres" className="padding-right-20">Adres</label>
                                <input
                                    className="input-field"
                                    type="text"
                                    id="adres"
                                    name="adres"
                                    value={formData.adres}
                                    title="Wprowadź adres"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                    <label htmlFor="zipCode" className="padding-right-20">Kod pocztowy</label>
                                    <input
                                        className="input-field"
                                        type="text"
                                        id="zipCode"
                                        name="zipCode"
                                        value={formData.zipCode}
                                        title="Wprowadź kod pocztowy"
                                        onChange={handleInputChange}
                                        required
                                    />
                            </div>
                            <div className="flex-container-space-between border-bottom-light">
                                    <label htmlFor="city" className="padding-right-20">Miejscowość</label>
                                    <input
                                        className="input-field"
                                        type="text"
                                        id="city"
                                        name="city"
                                        value={formData.city}
                                        title="Wprowadź miejscowość"
                                        onChange={handleInputChange}
                                        required
                                        readOnly={true}
                                    />
                            </div>
                        </>}

                    {modalViewActualTab === "Opis" &&
                        <div style={{ position: 'relative' }}>
                            <label className="description-small-padding" htmlFor="description-add">Opis</label>
                            <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <textarea
                                    type="text"
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    required
                                    className="event-description-add"
                                    style={{ flexGrow: 1 }}
                                />
                            </div>
                            <div className="flex-line border-bottom-light" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px' }}>
                                <label className="padding-right-20" htmlFor="tagList">Tagi</label>
                                <div id="tagList" className="tag-list" >
                                    {formData.tags.length > 0 ? (
                                        formData.tags.map((tag, index) => (
                                            <span key={`${tag}-${index}`} className="tag-item">
                                                {tag}
                                                <button
                                                    type="button"
                                                    className="button-orange-rounded-very-tiny-textonly"
                                                    onClick={() => handleRemoveTag(index)}
                                                    title="Usun tag"
                                                >
                                                    x
                                                </button>
                                            </span>
                                        ))
                                    ) : (
                                        <span>Brak tagow</span>
                                    )}
                                </div>
                                <button
                                    type="button"
                                    className="button-orange-rounded-tiny-plus"
                                    onClick={() => setIsTagModalOpen(true)}
                                    title="Dodaj tag"
                                >
                                    +
                                </button>
                            </div>
                        </div>}



                    {modalViewActualTab === "Opis" &&
                        <>
                            <div className="flex-line-add-modal">
                                <label htmlFor="mainImageInput" className="padding-right-20">Zdjęcie główne</label>
                                <input
                                    className="input-field file-max-width"
                                    type="file"
                                    id="mainImageInput"
                                    name="mainImageInput"
                                    onChange={handleMainImageChange}
                                    title="Wybierz plik obrazka głównego"
                                    accept="image/png, image/jpeg, image/webp"
                                />
                                <img
                                    src={mainImage.preview || defaultPlaceholder}
                                    className="imgMiniature"
                                    alt="Podgląd głównego zdjęcia"
                                />
                            </div>
                            <div className="flex-line-add-modal border-bottom-light">
                                <label htmlFor="additionalImagesInput" className="padding-right-20">Zdjęcia dodatkowe</label>
                                <input
                                    className="input-field file-max-width-2"
                                    type="file"
                                    id="additionalImagesInput"
                                    name="additionalImagesInput"
                                    onChange={handleAdditionalImagesChange}
                                    multiple // Obsługa wielu plików
                                    title="Wybierz pliki obrazków dodatkowych"
                                    accept="image/png, image/jpeg, image/webp"
                                />
                            </div>
                            <div className="flex-line2 border-bottom-light">
                                {additionalImages.length > 0 ? (
                                    additionalImages.map((imgData, index) => (
                                        <div key={index} className="image-container">
                                            <img
                                                src={imgData.preview}
                                                className="imgMiniature"
                                                alt={`Dodatkowe ${index}`}
                                            />

                                            {/* Nakładka widoczna po najechaniu myszką */}
                                            <div className="image-overlay ">
                                                {/* Górna część: Usuń */}
                                                <div
                                                    className="overlay-action overlay-action-top  delete"
                                                    onClick={() => handleRemoveImage(index)}
                                                    title="Usuń to zdjęcie"
                                                >
                                                    Usuń
                                                </div>

                                                {/* Dolna część: Ustaw główne */}
                                                <div
                                                    className="overlay-action overlay-action-bottom set-main"
                                                    onClick={() => handleSwapImage(index)}
                                                    title="Ustaw jako zdjęcie główne"
                                                >
                                                    Główne
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    // Wyświetlanie placeholderów gdy brak zdjęć dodatkowych
                                    <>
                                        {/*<img src={defaultPlaceholder} className="imgMiniature" alt="puste" />*/}
                                    </>
                                )}
                            </div>

                        </>
                    }

                <div className="modal-margin-top-20 modal-actions">
                    <div className="modal-actions-left">
                        <button className="button-orange-rounded-tiny-textonly" type="button" onClick={handleCloseModal}>
                            Anuluj
                        </button>
                        <button className="button-orange-rounded-tiny" disabled={isFirstTab} type="button" onClick={handlePrevButtonClick}>
                            <span className="fontX-tiny">&larr;&nbsp;</span>Wstecz
                        </button>
                    </div>
                    <div className="modal-actions-right">
                        <button className="button-orange-rounded-tiny" disabled={isLastTab} type="button" onClick={handleNextButtonClick}>
                            Dalej<span className="fontX-tiny">&nbsp;&rarr;</span>
                        </button>
                        <button type="submit" disabled={isSubmitDisabled} className="button-orange-backgrounded-tiny">
                            {/*<span className="fontX-tiny">&#8862;&nbsp;</span>*/}
                            <div className="step-box-plus"></div> {isAddModalOpen ? "Dodaj wydarzenie" : ""} {isEditModalOpen ? "Zapisz zmiany": ""}
                        </button>
                    </div>
                </div>
                </form>
            </Modal> }
        </>
    );
}

export default AddEvent;
